import { CopiarOcorrenciaFormModel } from "../modelos/ocorrencia/copiarOcorrenciaFormModel";

export const COPIAR_OCORRENCIA_FORM_INITIAL_STATE: CopiarOcorrenciaFormModel = {
    idOcorrencia: "",
    novaData: new Date(),
    
  };
  